import { t } from 'i18next';

export const CategoricalGroupUnionPluginSettings = (): IPluginSettings => {
    let index = 0
    return {
        name: t('directory.categoricalGroup.CategoricalGroupUnionPluginSettings.gridPluginName'),
        mnemocode: "categorical_group_union_plugin",
        permission: "CategoricalGroup",
        columns: [
            {
                order: index++,
                propertyName: "idGlobal",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupUnionPluginSettings.idGlobal'),
                visibility: false,
                width: 160,
            },
            {
                order: index++,
                propertyName: "code",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupUnionPluginSettings.code'),
                visibility: true,
                width: 160,
            },
            {
                order: index++,
                propertyName: "name",
                propertyType: "string",
                displayName: t('directory.categoricalGroup.CategoricalGroupUnionPluginSettings.name'),
                visibility: true,
                width: 360,
            },
        ],
    }
};
